import { ENV } from "../env";

export class Authorization {
    static async SetCredentials(response) {
        const responseJson = await response.json();
        localStorage.setItem("userEmail", responseJson.email);
        localStorage.setItem("userRole", responseJson["custom:role"]);
    }

    static async Authorize() {
        const response = await fetch(`${ENV.REACT_APP_LAMBDAS_BASE_URL}/Ping`);
        const isAuthorized = response.status === 200;

        if (isAuthorized) {
            await this.SetCredentials(response);
            return;
        }

        const code = new window.URLSearchParams(window.location.search).get("code");
        if (!code) {
            throw new Error("Not logged in. Should be redirected to login screen");
        }

        const postParams = {
            grant_type: "authorization_code",
            client_id: ENV.REACT_APP_CLIENT_ID,
            redirect_uri: ENV.REACT_APP_HOME_PAGE_URL,
            code: code
        };

        var cookiesResponse = await fetch(`${ENV.REACT_APP_LAMBDAS_BASE_URL}/Cookies`, {
            mode: 'cors',
            method: 'POST',
            body: JSON.stringify(postParams)
        });
        if (cookiesResponse.status !== 200) {
            throw new Error("Error issuing cookies");
        }

        await this.SetCredentials(cookiesResponse);
        window.history.pushState(null, "", '/');
    }

    static Logout() {
        fetch(
            `${ENV.REACT_APP_LAMBDAS_BASE_URL}/Logout?client_id=${ENV.REACT_APP_CLIENT_ID}&redirect_uri=${ENV.REACT_APP_HOME_PAGE_URL}&response_type=code`,
            {
                redirect: 'manual'
            }
        ).then(() => {
            window.location.assign("/");
        });
    }

    static NavigateToLogin() {
        window.location.assign(`${ENV.REACT_APP_COGNITO_URL}/login?client_id=${ENV.REACT_APP_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=${ENV.REACT_APP_HOME_PAGE_URL}`)
    }
}